import React, { useEffect, useState } from "react";
import { isCapacitorPlatform } from "./helpers";
import safeAreaInsets from "safe-area-insets";

/**
 * if capacitor true attaches onChange listener
 * @returns padding with 0px as values
 */
export default function useSafeAreaListener(): string {
	const [safeaAreaPadding, setSafeAreaPadding] = useState("0px 0px 0px 0px");

	useEffect(() => {
		if (isCapacitorPlatform()) {
			setSafeAreaPadding(
				`${safeAreaInsets.top}px ${safeAreaInsets.right}px ${safeAreaInsets.bottom}px ${safeAreaInsets.left}px`
			);
			safeAreaInsets.onChange(() => {
				setSafeAreaPadding(
					`${safeAreaInsets.top}px ${safeAreaInsets.right}px ${safeAreaInsets.bottom}px ${safeAreaInsets.left}px`
				);
			});
		}
		return () =>
			safeAreaInsets.offChange(() => {
				setSafeAreaPadding("0px 0px 0px 0px");
			});
	}, []);

	return safeaAreaPadding;
}
